export const formatosFecha = [
  "DD/MM/YYYY",
  "D/M/YY",
  "DD/MM/YY",
  "D/M/YYYY",
  "DD-MM-YYYY",
  "D-M-YY",
  "DD-MM-YY",
  "D-M-YYYY",
  "YYYY/MM/DD",
  "YY/M/D",
  "YY/MM/DD",
  "YYYY/M/D",
  "YYYY-MM-DD",
  "YY-M-D",
  "YY-MM-DD",
  "YYYY-M-D",
];

export function getDateStringYYYYMMDD(){
    const today = new Date();
    const fechaActual = today.toISOString().split("T")[0];
    return fechaActual;
}

export function getNewFormattedDate(){

    const now = new Date();

    // Obtener la diferencia en horas entre la zona horaria local (Argentina) y UTC
    const offset = -3; // Argentina está generalmente en UTC-3
    const localDate = new Date(now.getTime() + offset * 60 * 60 * 1000);

    // Formatear la fecha en formato ISO 8601 con el offset `+00:00`
    const formattedDate = localDate.toISOString().replace("Z", "+00:00");
    return  formattedDate
}